import React from 'react'
import Hero from './hero'
import Content from './content'

const Index = () => {
  return (
    <>
    <Hero/>
    <Content/>
    </>
  )
}

export default Index
